(function ($) {

    window.setImageTextCarouselContentHeight = function (target) {
        var $target = $(target);
        var maxHeight = 0;
        var $containers = $target.find(".carousel-slide-content-container");
        $containers.each(function () {
            var $this = $(this);
            $this.height("auto");
            if ($this.height() > maxHeight) {
                maxHeight = $this.height();
            }
        });
        $containers.height(maxHeight);
    }

    $(function () {

        $(window).resize(function () {
            $(".image-text-carousel .carousel").each(function () {
                setImageTextCarouselContentHeight(this);
            });
        }).trigger("resize");

        $(".image-text-carousel .carousel").on("cycle-initialized", function (event) {
            setImageTextCarouselContentHeight(event.target);
        }).cycle({
            autoHeight: "calc",
            fx: "scrollHorz",
            next: "+ .carousel-controls .carousel-control-next",
            pager: "+ .carousel-controls .carousel-pager",
            pagerTemplate: '<div></div>',
            paused: true,
            prev: "+ .carousel-controls .carousel-control-prev",
            slides: "> .carousel-slide"
        });

    });

})($JQ);
